import { css } from '@emotion/core';

export const TABLET = 768;
export const DESKTOP_WIDE = 1270;

export const mediaPhone = `@media (max-width: ${TABLET - 1}px)`;
export const mediaTablet = `@media (max-width: ${DESKTOP_WIDE - 1}px)`;

export const onlyTablet = `@media (min-width: ${TABLET}px) and (max-width: ${DESKTOP_WIDE - 1}px)`;

export const minTablet = `@media (min-width: ${TABLET}px)`;
export const minDesktop = `@media (min-width: ${DESKTOP_WIDE}px)`;

export const showOnlyOnDesktop = css`
  display: none;
  ${minDesktop} {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styles/breakpoints.js